import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useGetCustomerQuery } from '@/api/v1';
import { useLogout } from '@/hooks/useLogout';
import { Dashboard } from '@/Screens/Dashboard';
import { VerifyBusiness } from '@/Screens/VerifyBusiness';

const PrivateRoutes: React.FC = (): React.ReactElement => {
  const { isError } = useGetCustomerQuery();
  const logout = useLogout();

  if (isError) {
    logout();

    return <></>;
  }

  return (
    <Routes>
      <Route path="/verify-business/*" element={<VerifyBusiness />} />
      <Route path="/*" element={<Dashboard />} />
      <Route path="/logout" element={<Navigate to="/" replace={true} />} />

      <Route path="*" element={<Navigate to="/dashboard" replace={true} />} />
    </Routes>
  );
};

export default PrivateRoutes;
